import { useTheme } from '@emotion/react';
import { IconButton } from '@lib/uikit';
import { FC } from 'react';

import { withURLValidation } from '../hocs/withURLValidation';
import { ShareButtonProps } from '../types';
import { getIconName } from '../utils/getIconName';
import { buildShareLink } from '../utils/links';

export const ShareButton: FC<ShareButtonProps<'a'>> = withURLValidation(
    ({ url, network, onClick, ...iconButtonProps }) => {
        const { palette } = useTheme();

        return (
            <IconButton
                size='large'
                color={palette.common.black}
                {...iconButtonProps}
                as='a'
                icon={getIconName(network)}
                href={buildShareLink(network, url)}
                target='_blank'
                onClick={() => onClick?.(network)}
            />
        );
    }
);
